import { render, staticRenderFns } from "./FormHideSalary.vue?vue&type=template&id=63256549&scoped=true"
import script from "./FormHideSalary.vue?vue&type=script&lang=js"
export * from "./FormHideSalary.vue?vue&type=script&lang=js"
import style0 from "./FormHideSalary.vue?vue&type=style&index=0&id=63256549&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63256549",
  null
  
)

export default component.exports